module.exports = __webpack_public_path__ + "static/media/es-logo.b77ef362.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/es-logo.png
// module id = 490
// module chunks = 0